import { ChangeDetectionStrategy, Component, inject, Input } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';

import { VendorDropdownComponent } from '@shared/components/vendor-dropdown/vendor-dropdown.component';
import { OrganizationQuery } from '@shared/store/organization/organization.query';

import {
  BudgetCompareMenuFlatten$,
  BudgetCompareMenuVendorChangeFn,
  BudgetCompareMenuVendorFormControl,
  BudgetCompareMenuVendorLoading,
  defaultVendorChangeFn,
} from '../../models/budget-compare-menu.models';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [VendorDropdownComponent, ReactiveFormsModule],
  selector: 'aux-budget-compare-menu-vendor',
  templateUrl: './budget-compare-menu-vendor.component.html',
})
export class BudgetCompareMenuVendorComponent {
  private organizationQuery = inject(OrganizationQuery);

  @Input() vendorChangeFn: BudgetCompareMenuVendorChangeFn;
  @Input() vendorFormControl: BudgetCompareMenuVendorFormControl;
  @Input() vendorList: BudgetCompareMenuFlatten$<typeof this.organizationQuery.allVendors$>;
  @Input() vendorLoading: BudgetCompareMenuVendorLoading;

  constructor() {
    this.vendorFormControl = new FormControl<string>('', { nonNullable: true });
    this.vendorList = [];
    this.vendorLoading = false;
    this.vendorChangeFn = defaultVendorChangeFn;
  }
}
